module.exports = __webpack_public_path__ + "img/v3.b951f1f9.png";